export default __webpack_public_path__ + "static/patent-cost-estimate-875d532d817e2198768ac7d58bd17ad2.png";